import { render, staticRenderFns } from "./subjectDetail.vue?vue&type=template&id=297623ea&scoped=true&"
import script from "./subjectDetail.vue?vue&type=script&lang=js&"
export * from "./subjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./subjectDetail.vue?vue&type=style&index=0&id=297623ea&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297623ea",
  null
  
)

export default component.exports